import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    type OpenApiDeleteRetailCRMSetupRequest,
    type OpenApiDeleteRetailCRMSetupResponseSuccess,
    type OpenApiGetRetailCRMSetupRequest,
    type OpenApiGetRetailCRMSetupResponseSuccess,
    type OpenApiSetupRetailCRMRequest,
    type OpenApiSetupRetailCRMResponseSuccess,
} from '#shared/api/schema';

const api = createApi({
    name: 'entities/integration/api/retailCrmApi',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            setupAdd: builder.mutation<OpenApiSetupRetailCRMResponseSuccess, OpenApiSetupRetailCRMRequest>({
                query: (payload) => {
                    return {
                        url: '/integrations/retailcrm/setup',
                        method: 'POST',
                        body: payload,
                    };
                },
            }),
            setupDelete: builder.mutation<
                OpenApiDeleteRetailCRMSetupResponseSuccess,
                OpenApiDeleteRetailCRMSetupRequest
            >({
                query: () => {
                    return {
                        url: '/integrations/retailcrm/setup',
                        method: 'DELETE',
                    };
                },
            }),
            setupGet: builder.query<OpenApiGetRetailCRMSetupResponseSuccess, OpenApiGetRetailCRMSetupRequest>({
                query: () => {
                    return {
                        url: '/integrations/retailcrm/setup',
                        method: 'GET',
                    };
                },
            }),
            setLoyalty: builder.mutation<{}, { enabled: boolean }>({
                query: ({ enabled }) => {
                    return {
                        url: '/integrations/retailcrm/loyalty',
                        method: 'POST',
                        body: { enabled },
                    };
                },
            }),
        };
    },
});

export const integrationRetailCRMSetupAdd = api.endpoints.setupAdd.mutate;
export const integrationRetailCRMSetupDelete = api.endpoints.setupDelete.mutate;
export const integrationRetailCRMSetupGet = api.endpoints.setupGet.query;
export const useIntegrationRetailCRMSetup = api.useSetupGetQuery;
export const integrationRetailCRMSetLoyalty = api.endpoints.setLoyalty.mutate;
